export const REGEX_FRAGMENT: RegExp = /#([^?#]*)/;
export const REGEX_QUERY: RegExp = /\?([^?#]*)/;
export const REGEX_PERCENT = /%25/g;
export const REGEX_LPAREN = /%28/g;
export const REGEX_RPAREN = /%29/g;
export const REGEX_SPACE_ENCODED = /%20/g;
export const REGEX_HREF = /href="(?<href>\/[^"]+)"/g;
export const URL_REGEX =
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
